export default "__VITE_ASSET__df3da8dd__"